(function () {
  function all(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function initShell() {
    document.body.classList.add("cz-shot-page");
    var links = all(document, ".shot-rail a, .shot-main-nav a");
    var sections = all(document, ".cz-shot[id]");
    if (!("IntersectionObserver" in window) || !links.length || !sections.length) return;
    if (window.__czShotObserver) window.__czShotObserver.disconnect();
    window.__czShotObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        links.forEach(function (link) {
          link.classList.toggle("is-active", (link.getAttribute("href") || "").slice(1) === id);
        });
      });
    }, { threshold: 0.42 });
    sections.forEach(function (section) { window.__czShotObserver.observe(section); });
  }

  function initClans() {
    all(document, "[data-shot-clans]").forEach(function (section) {
      if (section.dataset.shotClansReady === "true") return;
      section.dataset.shotClansReady = "true";

      var panels = all(section, ".shot-panel");
      var buttons = all(section, "[data-shot-clan-toggle]");

      function buttonParts(button) {
        return {
          icon: button.querySelector("[data-shot-clan-icon]"),
          label: button.querySelector("[data-shot-clan-label]")
        };
      }

      function setButton(button, open) {
        var parts = buttonParts(button);
        if (parts.icon) parts.icon.textContent = open ? "×" : "☺";
        if (parts.label) parts.label.textContent = open ? (button.dataset.closeLabel || "Close") : (button.dataset.defaultLabel || "Learn more");
        button.setAttribute("aria-expanded", open ? "true" : "false");
      }

      function closeAll() {
        section.classList.remove("is-expanded");
        section.removeAttribute("data-active-index");
        panels.forEach(function (panel) {
          panel.classList.remove("is-active", "is-inactive");
          var copy = panel.querySelector(".shot-clan-copy");
          if (copy) copy.setAttribute("aria-hidden", "true");
        });
        buttons.forEach(function (button) { setButton(button, false); });
      }

      function openPanel(target, index) {
        section.classList.add("is-expanded");
        section.setAttribute("data-active-index", String(index));
        panels.forEach(function (panel) {
          var active = panel === target;
          panel.classList.toggle("is-active", active);
          panel.classList.toggle("is-inactive", !active);
          var copy = panel.querySelector(".shot-clan-copy");
          if (copy) copy.setAttribute("aria-hidden", active ? "false" : "true");
        });
        buttons.forEach(function (button) {
          setButton(button, button.closest(".shot-panel") === target);
        });
      }

      buttons.forEach(function (button, index) {
        button.addEventListener("click", function () {
          var panel = button.closest(".shot-panel");
          if (!panel) return;
          if (panel.classList.contains("is-active")) {
            closeAll();
          } else {
            openPanel(panel, index);
          }
        });
      });

      closeAll();
    });
  }

  function initVision() {
    all(document, "[data-shot-vision]").forEach(function (section) {
      if (section.dataset.shotReady === "true") return;
      section.dataset.shotReady = "true";

      var cards = all(section, "[data-shot-card]");
      var copyNumber = section.querySelector("[data-shot-vision-number]");
      var copyTitle = section.querySelector("[data-shot-vision-title]");
      var copyBody = section.querySelector("[data-shot-vision-body]");
      var copy = section.querySelector(".shot-vision__copy");
      var posterLabel = section.querySelector("[data-shot-poster-label]");
      var posterMedia = section.querySelector("[data-shot-poster-media]");
      var posterWrap = section.querySelector(".shot-poster-wrap");
      var posterStage = section.querySelector("[data-shot-poster-stage]") || section.querySelector(".shot-poster-stage") || posterWrap;
      var poster = section.querySelector(".shot-poster");
      var stickers = all(section, ".shot-sticker");
      var buttons = all(section, "[data-shot-prev], [data-shot-next]");
      var active = 0; // Always start a fresh page visit on the first card: 01 Choose Shape.
      var swapToken = 0;
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function isMobile() {
        return window.matchMedia("(max-width: 749px)").matches;
      }

      function finalPosterTransform(cardIndex) {
        var tilt = [1.6, -1.8, 2.4, -2.2, 1.2, -1.4, 1.9, -2.5][cardIndex % 8];
        return "translate3d(0, 0, 0) rotate(" + tilt + "deg) scale(1)";
      }

      function setButtons(disabled) {
        buttons.forEach(function (button) {
          button.disabled = disabled;
          button.setAttribute("aria-disabled", disabled ? "true" : "false");
        });
      }

      function animateElement(element, keyframes, options) {
        if (!element || reduceMotion || !element.animate) {
          return Promise.resolve();
        }
        return new Promise(function (resolve) {
          var animation = element.animate(keyframes, options);
          animation.addEventListener("finish", resolve, { once: true });
          animation.addEventListener("cancel", resolve, { once: true });
        });
      }

      function makePosterGhost() {
        if (!poster || !posterStage) return null;
        var rect = posterStage.getBoundingClientRect();
        var ghost = document.createElement("div");
        ghost.className = "shot-poster-visual--ghost";
        ghost.style.position = "fixed";
        ghost.style.left = rect.left + "px";
        ghost.style.top = rect.top + "px";
        ghost.style.width = rect.width + "px";
        ghost.style.height = rect.height + "px";
        ghost.style.zIndex = "40";
        stickers.forEach(function (sticker) {
          var stickerGhost = sticker.cloneNode(true);
          stickerGhost.classList.add("shot-sticker--ghost");
          ghost.appendChild(stickerGhost);
        });
        var posterGhost = poster.cloneNode(true);
        posterGhost.classList.add("shot-poster--ghost");
        posterGhost.style.transform = poster.style.transform || finalPosterTransform(active);
        ghost.appendChild(posterGhost);
        document.body.appendChild(ghost);
        return ghost;
      }

      function setLiveDecorHidden(hidden) {
        // Keep the live/new card decorations visible. The moving ghost carries its own sticker copies.
      }

      function cleanupGhost(ghost) {
        if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }

      function trimGhosts() {
        var ghosts = all(section, ".shot-poster-visual--ghost");
        ghosts.slice(0, Math.max(0, ghosts.length - 3)).forEach(cleanupGhost);
      }

      function animatePosterIn(direction, cardIndex) {
        if (!poster) return Promise.resolve();
        poster.style.opacity = "";
        poster.style.transform = finalPosterTransform(cardIndex);
        return Promise.resolve();
      }

      function animatePosterOut(direction, cardIndex, targetOverride) {
        var target = targetOverride || poster;
        if (!target) return Promise.resolve();
        var mobile = isMobile();
        var sign = direction > 0 ? 1 : -1;
        var rect = target.getBoundingClientRect ? target.getBoundingClientRect() : null;
        var exitX = sign > 0 && rect ? (window.innerWidth - rect.left + rect.width + (mobile ? 80 : 140)) : sign * (mobile ? 760 : 1180);
        var exitY = direction > 0 ? (mobile ? -150 : -235) : (mobile ? 150 : 235);
        var exitRotate = sign * 3.2;
        var isVisualGhost = target.classList && target.classList.contains("shot-poster-visual--ghost");
        var startTransform = isVisualGhost ? "translate3d(0, 0, 0) rotate(0deg) scale(1)" : (target.style.transform || finalPosterTransform(cardIndex));
        return animateElement(target, [
          { transform: startTransform, opacity: 1 },
          { transform: "translate3d(" + (exitX * 0.22) + "px, " + (exitY * 0.22) + "px, 0) rotate(" + (exitRotate * 0.22) + "deg) scale(.998)", opacity: 1, offset: 0.22 },
          { transform: "translate3d(" + (exitX * 0.58) + "px, " + (exitY * 0.58) + "px, 0) rotate(" + (exitRotate * 0.58) + "deg) scale(.992)", opacity: 1, offset: 0.58 },
          { transform: "translate3d(" + exitX + "px, " + exitY + "px, 0) rotate(" + exitRotate + "deg) scale(.985)", opacity: 1 }
        ], {
          duration: mobile ? 720 : 560,
          easing: "linear",
          fill: "forwards"
        });
      }

      function animateCopyOut(direction) {
        if (!copy) return Promise.resolve();
        var sign = direction > 0 ? 1 : -1;
        return animateElement(copy, [
          { transform: "translate3d(0, 0, 0) scale(1)", opacity: 1 },
          { transform: "translate3d(" + (sign * 14) + "px, 10px, 0) scale(.992)", opacity: 0 }
        ], {
          duration: 260,
          easing: "cubic-bezier(.4, 0, 1, 1)",
          fill: "forwards"
        });
      }

      function animateCopyIn(direction) {
        if (!copy) return Promise.resolve();
        var mobile = isMobile();
        var sign = direction > 0 ? 1 : -1;
        copy.style.opacity = "0";
        copy.style.transform = "translate3d(" + (sign * -10) + "px, 8px, 0) scale(.995)";
        return animateElement(copy, [
          { transform: copy.style.transform, opacity: 0 },
          { transform: "translate3d(0, 0, 0) scale(1)", opacity: 1 }
        ], {
          duration: mobile ? 280 : 250,
          delay: mobile ? 260 : 0,
          easing: "cubic-bezier(.16, 1, .3, 1)",
          fill: "forwards"
        }).then(function () {
          copy.style.opacity = "";
          copy.style.transform = "";
        });
      }

      function setCssVar(name, value, fallback) {
        section.style.setProperty(name, value || fallback || "");
      }

      function applyPosterCard(card) {
        if (!card) return;
        if (posterLabel) posterLabel.textContent = card.dataset.label || "";
        if (posterMedia) {
          posterMedia.innerHTML = card.innerHTML || "";
          posterMedia.classList.toggle("is-empty", !card.innerHTML.trim());
          all(posterMedia, "video").forEach(function (video) {
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            var play = video.play && video.play();
            if (play && play.catch) play.catch(function () {});
          });
        }
        section.classList.toggle("has-vision-media", !!(card.dataset.mediaType || card.innerHTML.trim()));
        if (poster) {
        }
      }


      function alignToJustify(value) {
        if (value === "center") return "center";
        if (value === "right") return "end";
        return "start";
      }

      function applyCopyCard(card) {
        if (!card) return;
        if (copyNumber) copyNumber.textContent = card.dataset.number || "01";
        if (copyTitle) copyTitle.textContent = card.dataset.title || "";
        if (copyBody) copyBody.textContent = card.dataset.body || "";
        setCssVar("--vision-number-size", (card.dataset.numberSize || 84) + "px");
        setCssVar("--vision-number-color", card.dataset.numberColor, "#fff7e8");
        setCssVar("--vision-number-bg", card.dataset.numberBg, "transparent");
        setCssVar("--vision-title-size", (card.dataset.titleSize || 58) + "px");
        setCssVar("--vision-title-color", card.dataset.titleColor, "#111111");
        setCssVar("--vision-title-bg", card.dataset.titleBg, "#caff35");
        setCssVar("--vision-body-size", (card.dataset.bodySize || 20) + "px");
        setCssVar("--vision-body-color", card.dataset.bodyColor, "#fff7e8");
        setCssVar("--vision-body-bg", card.dataset.bodyBg, "transparent");
        setCssVar("--vision-mobile-number-size", (card.dataset.mobileNumberSize || card.dataset.numberSize || 72) + "px");
        setCssVar("--vision-mobile-number-color", card.dataset.mobileNumberColor || card.dataset.numberColor, "#fff7e8");
        setCssVar("--vision-mobile-number-bg", card.dataset.mobileNumberBg || card.dataset.numberBg, "transparent");
        setCssVar("--vision-mobile-number-align", card.dataset.mobileNumberAlign || "left", "left");
        setCssVar("--vision-mobile-number-justify", alignToJustify(card.dataset.mobileNumberAlign), "start");
        setCssVar("--vision-mobile-title-size", (card.dataset.mobileTitleSize || card.dataset.titleSize || 50) + "px");
        setCssVar("--vision-mobile-title-color", card.dataset.mobileTitleColor || card.dataset.titleColor, "#111111");
        setCssVar("--vision-mobile-title-bg", card.dataset.mobileTitleBg || card.dataset.titleBg, "#caff35");
        setCssVar("--vision-mobile-title-align", card.dataset.mobileTitleAlign || "left", "left");
        setCssVar("--vision-mobile-title-justify", alignToJustify(card.dataset.mobileTitleAlign), "start");
        setCssVar("--vision-mobile-body-size", (card.dataset.mobileBodySize || card.dataset.bodySize || 20) + "px");
        setCssVar("--vision-mobile-body-color", card.dataset.mobileBodyColor || card.dataset.bodyColor, "#fff7e8");
        setCssVar("--vision-mobile-body-bg", card.dataset.mobileBodyBg || card.dataset.bodyBg, "transparent");
        setCssVar("--vision-mobile-body-align", card.dataset.mobileBodyAlign || "left", "left");
        setCssVar("--vision-mobile-body-justify", alignToJustify(card.dataset.mobileBodyAlign), "start");
      }

      function applyCard(card) {
        applyPosterCard(card);
        applyCopyCard(card);
      }

      function setStackDirection(direction) {
        if (!posterWrap) return;
        posterWrap.classList.remove("is-card-prev", "is-card-next");
        posterWrap.classList.add(direction > 0 ? "is-card-next" : "is-card-prev");
        window.setTimeout(function () {
          posterWrap.classList.remove("is-card-prev", "is-card-next");
        }, 520);
      }

      function render(index, direction, immediate) {
        if (!cards.length) return;
        var nextIndex = (index + cards.length) % cards.length;
        var nextCard = cards[nextIndex];
        var motionDirection = direction || (nextIndex >= active ? 1 : -1);
        var currentToken = ++swapToken;

        if (immediate || reduceMotion || !poster) {
          active = nextIndex;
          applyCard(nextCard);
          if (poster) poster.style.transform = finalPosterTransform(active);
          if (posterStage) {
            posterStage.style.opacity = "";
            posterStage.style.transform = "";
          }
          if (poster) poster.style.opacity = "";
          if (copy) {
            copy.style.opacity = "";
            copy.style.transform = "";
            copy.style.filter = "";
          }
          return;
        }

        setStackDirection(motionDirection);
        section.classList.add("is-vision-swapping");
        var previousIndex = active;
        var ghost = makePosterGhost();
        trimGhosts();
        active = nextIndex;

        animateCopyOut(motionDirection).then(function () {
          if (currentToken === swapToken && copy) {
            copy.style.opacity = "0";
            copy.style.transform = "translate3d(0, 12px, 0) scale(.99)";
          }
        });

        applyPosterCard(nextCard);
        animatePosterIn(motionDirection, active);

        var copyDelay = isMobile() ? 180 : 180;
        window.setTimeout(function () {
          if (currentToken !== swapToken) return;
          applyCopyCard(nextCard);
          animateCopyIn(motionDirection);
        }, copyDelay);

        animatePosterOut(motionDirection, previousIndex, ghost).then(function () {
          cleanupGhost(ghost);
          if (currentToken === swapToken) {
            section.classList.remove("is-vision-swapping");
          }
        });
      }

      function runEntry() {
        if (section.dataset.visionEntered === "true") return;
        section.dataset.visionEntered = "true";
        section.classList.add("is-vision-entered");
        if (reduceMotion || !posterStage) return;
        var mobile = isMobile();
        posterStage.style.opacity = "0";
        posterStage.style.transform = "translate3d(" + (mobile ? -210 : -340) + "px, " + (mobile ? 34 : 18) + "px, 0) rotate(-9deg) scale(.94)";
        if (copy) {
          copy.style.opacity = "0";
          copy.style.transform = "translate3d(" + (mobile ? 24 : 74) + "px, 26px, 0)";
        }
        Promise.all([
          animateElement(posterStage, [
            { transform: posterStage.style.transform, opacity: 0 },
            { transform: "translate3d(20px, -8px, 0) rotate(1.5deg) scale(1.015)", opacity: 1, offset: 0.74 },
            { transform: "translate3d(0, 0, 0) rotate(0) scale(1)", opacity: 1 }
          ], {
            duration: mobile ? 760 : 920,
            easing: "cubic-bezier(.16, 1, .3, 1)",
            fill: "forwards"
          }),
          animateElement(copy, [
            { transform: copy ? copy.style.transform : "translate3d(74px, 26px, 0)", opacity: 0 },
            { transform: "translate3d(0, 0, 0)", opacity: 1 }
          ], {
            duration: mobile ? 560 : 700,
            delay: mobile ? 170 : 260,
            easing: "cubic-bezier(.16, 1, .3, 1)",
            fill: "forwards"
          })
        ]).then(function () {
          posterStage.style.opacity = "";
          posterStage.style.transform = "";
          posterStage.style.filter = "";
          if (copy) {
            copy.style.opacity = "";
            copy.style.transform = "";
          }
        });
      }

      if (!cards.length) return;
      active = 0; // Always start a fresh page visit on the first card: 01 Choose Shape.
      applyCard(cards[active]);
      if (poster) poster.style.transform = finalPosterTransform(active);

      all(section, "[data-shot-prev]").forEach(function (button) {
        button.addEventListener("click", function () { render(active - 1, -1); });
      });
      all(section, "[data-shot-next]").forEach(function (button) {
        button.addEventListener("click", function () { render(active + 1, 1); });
      });

      function focusEditorCard(cardIndex) {
        if (cardIndex < 0 || cardIndex >= cards.length) return;
        render(cardIndex, cardIndex >= active ? 1 : -1, true);
        runEntry();
        window.setTimeout(function () {
          section.scrollIntoView({ block: "center", behavior: "smooth" });
        }, 30);
      }

      section.addEventListener("shopify:block:select", function (event) {
        var selectedBlock = event.target && event.target.closest ? event.target.closest("[data-shot-card]") : null;
        if (!selectedBlock || !section.contains(selectedBlock)) return;
        var selectedIndex = cards.indexOf(selectedBlock);
        focusEditorCard(selectedIndex);
      });

      section.addEventListener("shopify:section:select", function () {
        runEntry();
        window.setTimeout(function () {
          section.scrollIntoView({ block: "center", behavior: "smooth" });
        }, 30);
      });

      var startX = 0;
      section.addEventListener("pointerdown", function (event) { startX = event.clientX; });
      section.addEventListener("pointerup", function (event) {
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 44) render(active + (delta < 0 ? 1 : -1), delta < 0 ? 1 : -1);
      });

      if ("IntersectionObserver" in window) {
        var entryObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            runEntry();
            entryObserver.disconnect();
          });
        }, { threshold: 0.38 });
        entryObserver.observe(section);
      } else {
        window.setTimeout(runEntry, 180);
      }
    });
  }

  function initTeam() {
    all(document, "[data-shot-team]").forEach(function (section) {
      if (section.dataset.shotReady === "true") return;
      section.dataset.shotReady = "true";

      var rail = section.querySelector("[data-shot-team-rail]");
      if (!rail) return;

      if (section.__czShotTeamAbort) section.__czShotTeamAbort.abort();
      var teamAbort = "AbortController" in window ? new AbortController() : null;
      var teamEventOptions = teamAbort ? { signal: teamAbort.signal } : false;
      section.__czShotTeamAbort = teamAbort;

      var step = function () {
        var card = rail.querySelector(".shot-member");
        var gap = window.matchMedia("(max-width: 749px)").matches ? 28 : 89;
        return card ? card.getBoundingClientRect().width + gap : 390;
      };
      var prev = section.querySelector("[data-shot-team-prev]");
      var next = section.querySelector("[data-shot-team-next]");
      if (prev) prev.addEventListener("click", function () {
        rail.scrollBy({ left: -step(), behavior: "smooth" });
      }, teamEventOptions);
      if (next) next.addEventListener("click", function () {
        rail.scrollBy({ left: step(), behavior: "smooth" });
      }, teamEventOptions);

      var cards = all(section, "[data-ugc-card]");
      if (!cards.length) cards = all(section, ".shot-member");
      var hoverPointer = window.matchMedia ? window.matchMedia("(hover: hover) and (pointer: fine)") : { matches: true };

      function syncUgcActiveState() {
        var active = cards.some(function (card) {
          return card.classList.contains("is-ugc-active") || card.matches(":hover") || card.contains(document.activeElement);
        });
        section.classList.toggle("has-ugc-active", active);
        rail.classList.toggle("has-ugc-active", active);
      }

      function activateUgcCard(card) {
        cards.forEach(function (item) {
          if (item !== card) item.classList.remove("is-ugc-active");
        });
        card.classList.add("is-ugc-active");
        syncUgcActiveState();
      }

      function deactivateUgcCard(card) {
        card.classList.remove("is-ugc-active");
        syncUgcActiveState();
      }

      cards.forEach(function (card) {
        if (!card.hasAttribute("tabindex")) card.setAttribute("tabindex", "0");
        card.addEventListener("pointerenter", function (event) {
          if (event.pointerType === "touch" || !hoverPointer.matches) return;
          activateUgcCard(card);
        }, teamEventOptions);
        card.addEventListener("pointerleave", function () {
          if (!card.contains(document.activeElement)) deactivateUgcCard(card);
        }, teamEventOptions);
        card.addEventListener("pointerdown", function (event) {
          if (event.pointerType === "touch" || event.pointerType === "pen") activateUgcCard(card);
        }, teamEventOptions);
        card.addEventListener("click", function () {
          activateUgcCard(card);
        }, teamEventOptions);
        card.addEventListener("focusin", function () {
          activateUgcCard(card);
        }, teamEventOptions);
        card.addEventListener("focusout", function () {
          window.setTimeout(function () {
            if (!card.contains(document.activeElement) && !card.matches(":hover")) deactivateUgcCard(card);
          }, 0);
        }, teamEventOptions);
        card.addEventListener("keydown", function (event) {
          if (event.key !== "Escape") return;
          deactivateUgcCard(card);
          if (card.blur) card.blur();
        }, teamEventOptions);
      });

      section.addEventListener("pointerdown", function (event) {
        if (event.target.closest(".shot-member")) return;
        cards.forEach(deactivateUgcCard);
      }, teamEventOptions);

      all(section, ".shot-member__image video").forEach(function (video) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        var playAttempt = video.play && video.play();
        if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
      });
    });
  }

  function initMotion() {
    if (!window.gsap || !window.ScrollTrigger || window.__czShotMotionReady || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    window.__czShotMotionReady = true;
    window.gsap.registerPlugin(window.ScrollTrigger);

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var mm = gsap.matchMedia();

    mm.add("(min-width: 750px)", function () {
      all(document, ".shot-panel").forEach(function (panel, index) {
        var image = panel.querySelector(".shot-character, .shot-character-fallback");
        if (!image) return;
        gsap.fromTo(image, {
          y: 90,
          scale: 0.96,
          opacity: 0
        }, {
          y: 0,
          scale: 1,
          opacity: 1,
          duration: 0.95,
          delay: index * 0.08,
          ease: "expo.out",
          scrollTrigger: { trigger: panel, start: "top 76%" }
        });
      });

      gsap.fromTo(".shot-clans__title", { y: -36, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.75,
        ease: "expo.out",
        scrollTrigger: { trigger: ".shot-clans", start: "top 78%" }
      });

      all(document, ".shot-member").forEach(function (card, index) {
        gsap.fromTo(card, { y: 72, opacity: 0 }, {
          y: 0,
          opacity: 1,
          duration: 0.7,
          delay: Math.min(index * 0.06, 0.24),
          ease: "power3.out",
          onComplete: function () {
            gsap.set(card, { clearProps: "transform,opacity" });
          },
          scrollTrigger: { trigger: card, start: "top 88%" }
        });
      });
    });

    mm.add("(max-width: 749px)", function () {
      all(document, ".shot-clans").forEach(function (section) {
        all(section, ".shot-panel").forEach(function (panel, index) {
          var image = panel.querySelector(".shot-character, .shot-character-fallback");
          var copy = panel.querySelector(".shot-clan-copy");
          if (copy) {
            gsap.fromTo(copy, { y: 54, opacity: 0 }, {
              y: 0,
              opacity: 1,
              duration: 0.68,
              delay: index === 0 ? 0.08 : 0,
              ease: "power3.out",
              scrollTrigger: { trigger: panel, start: "top 72%", end: "top 34%", toggleActions: "play none none reverse" }
            });
          }
          if (image) {
            gsap.fromTo(image, { y: 92, scale: 0.96, opacity: 0.88 }, {
              y: 0,
              scale: 1,
              opacity: 1,
              duration: 0.78,
              ease: "power3.out",
              scrollTrigger: { trigger: panel, start: "top 68%", end: "top 20%", toggleActions: "play none none reverse" }
            });
          }
        });
      });

      all(document, ".shot-member").forEach(function (item) {
        gsap.fromTo(item, { y: 46, opacity: 0 }, {
          y: 0,
          opacity: 1,
          duration: 0.72,
          ease: "power3.out",
          onComplete: function () {
            gsap.set(item, { clearProps: "transform,opacity" });
          },
          scrollTrigger: { trigger: item, start: "top 84%" }
        });
      });
    });

    ScrollTrigger.refresh();
  }

  function boot() {
    initShell();
    initClans();
    initVision();
    initTeam();
    window.setTimeout(initMotion, 140);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function () {
    all(document, "[data-shot-clans], [data-shot-vision], [data-shot-team]").forEach(function (section) {
      section.dataset.shotReady = "false";
      section.dataset.shotClansReady = "false";
    });
    boot();
  });
})();
